import app from 'firebase/app';
import 'firebase/firebase-firestore';
import 'firebase/firebase-auth';
import 'firebase/firebase-storage';

const config = {
   apiKey: "AIzaSyCJR9q8ADczGt1ILWvsILriAIBrw9FOzBo",
   authDomain: "msp-salud.firebaseapp.com",
   projectId: "msp-salud",
   storageBucket: "msp-salud.appspot.com",
   messagingSenderId: "487615598757",
   appId: "1:487615598757:web:d7584b324d1b87e3773d4c",
   measurementId: "G-3G1LQCY0CN"
};

const secondaryApp = app.initializeApp(config, "Secondary");

class firebaseConfig {

   constructor() {
      app.initializeApp(config);
      this.db = app.firestore();
      this.auth = app.auth();
      this.authSecondary = secondaryApp.auth();
      this.storage = app.storage();

      this.storage.ref().constructor.prototype.saveDocuments = function(documents){
         var ref = this;
         return Promise.all(documents.map(function(file){
            return ref.child(file.alias).put(file).then(snapshot => {
               return ref.child(file.alias).getDownloadURL();
            })
         }))
      }
   }

   isStarted(){
      return new Promise(resolve => {
         this.auth.onAuthStateChanged(resolve)
      })
   }

   saveDocument = (nameDocument, document) => this.storage.ref().child(nameDocument).put(document);

   returnDocument = (documentUrl) => this.storage.ref().child(documentUrl).getDownloadURL();
   
   saveDocuments = (documents) => this.storage.ref().saveDocuments(documents);

   dropDocument = document => this.storage.ref().child(document).delete();
   
}

export default firebaseConfig;